// Centrální signál o vypršení přihlášení. Axios vrstva (mimo React) o 401 jen
// vystřelí DOM event; React UI (toast, navigace, záchrana formuláře) na něj reaguje.
// Tím zůstává interceptor frameworkově nezávislý a testovatelný.
import type { QueryClient } from 'react-query';

export const SESSION_EXPIRED_EVENT = 'auth:session-expired';

export const dispatchSessionExpired = () : void => {
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
    }
};

export const clearSessionQueries = async (queryClient : QueryClient, currentAuthQuery ?: string) : Promise<void> => {
    await queryClient.cancelQueries({ predicate: (query) => query.queryKey[0] !== currentAuthQuery });
    queryClient.removeQueries({ predicate: (query) => query.queryKey[0] !== 'fetchCurrentUser' && query.queryKey[0] !== currentAuthQuery });
    await queryClient.invalidateQueries(['fetchCurrentUser']);
};
